import TestPage from './TestPage.jsx'

export default () => {
    return {
        path: '/test',
        element: <TestPage />,
    }
}
